export default __webpack_public_path__ + "static/media/groupe_4637.07970da7.png";